import { render, staticRenderFns } from "./OnscreenMenu.vue?vue&type=template&id=096f8294&scoped=true&"
import script from "./OnscreenMenu.vue?vue&type=script&lang=ts&"
export * from "./OnscreenMenu.vue?vue&type=script&lang=ts&"
import style0 from "./OnscreenMenu.vue?vue&type=style&index=0&id=096f8294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f8294",
  null
  
)

export default component.exports